import { ISkillResource } from "../../skills";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkill } from "../types";

export interface ISkillQueryParameters {
    skill?: RelationalValue<ISkillResource>;
    learnerUuid?: string;
    locale?: string;
}

export type ISkillQueryResult = ISkill;

export const skillQuery: IApiQueryFunction<ISkillQueryParameters> = ({ skill, learnerUuid, locale }) => {
    if (!skill) {
        return;
    }

    const headers =
        learnerUuid || locale
            ? {
                  ...(learnerUuid ? { "x-learner-uuid": learnerUuid } : {}),
                  ...(locale ? { "x-locale": locale } : {}),
              }
            : undefined;

    return {
        method: "GET",
        url: `/skills/${mapRelationalValue(skill)}`,
        headers,
    };
};

export const useSkillQuery = createApiQueryHook<ISkillQueryParameters, ISkillQueryResult>(skillQuery);
